import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { getGoogleCodeFromUrl } from "../lib/auth";
import { useApp } from "../context/AppContext";
import { Spinner } from "../components/ui";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, loadEntities, loadWorkspaces, t } = useApp();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const code = getGoogleCodeFromUrl();
    const run = async () => {
      if (!code) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google", { code, redirect_uri: redirectUri });
        setUser(data);
        await loadWorkspaces();
        await loadEntities();
        // If the user arrived from an invite link, resume the accept flow instead
        // of dropping them on the dashboard (otherwise they'd have to reopen the link).
        const pendingInvite = localStorage.getItem("pending_invite_token");
        const dest = pendingInvite
          ? `/accept-invite?token=${encodeURIComponent(pendingInvite)}`
          : "/";
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true });
      } catch (err) {
        setError(err?.response?.data?.detail || t("auth_error_generic"));
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    };
    run();
  }, [navigate, setUser, loadEntities, loadWorkspaces, t]);

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-background gap-4">
      {error ? (
        <p className="text-sm text-red-400" data-testid="auth-callback-error">{error}</p>
      ) : (
        <>
          <Spinner className="w-8 h-8 text-text-secondary" />
          <p className="text-sm text-text-secondary">{t("signing_in")}</p>
        </>
      )}
    </div>
  );
}
